export const fetchSomeData = () => {
  return fetch('https://api.github.com/repos/javascript-tutorial/en.javascript.info/commits')
    .then(res => res)
    .then(res => res.json())
    .catch(error => console.log(error))
}
